import { Button, Select, Spin, Form } from 'antd'
import { useEffect, useState } from 'react'
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory, useParams } from 'react-router-dom'
import HeroPageTemplate from "components/dumb/HeroPageTemplate"
import PhoneInput from 'components/smart/PhoneInput';
import UserForm from 'components/smart/UserForm';
import { useIsMobileDevice } from "hooks"
import CompanyApi from 'services/apis/company'
import { storage } from 'services/config/storage'
import { DEFAULT_COUNTRY_DATA, SALES_TYPE_POSITION_MAP, SALES_TYPE_POSITIONS, SALES_TYPES_OPTIONS } from 'constants/globalConstants'
import { Dropdown } from 'assets/icons'
import "./style.scss"

const PositionsRandomizer = () => {
  const [companyLogo, setCompanyLogo] = useState(null)
  const [country, setCountry] = useState(DEFAULT_COUNTRY_DATA)
  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const history = useHistory()
  let { orgId, orgType } = useParams()
  const isMobile = useIsMobileDevice()
  const [userDetailForm] = Form.useForm()

  useEffect(() => {
    getCompanyLogo()
  }, [])

  const getCompanyLogo = async () => {
    try {
      const res = await CompanyApi.getCompanyLogo(orgId)
      if (res.mediaUrl) {
        setCompanyLogo(res.mediaUrl)
        storage.set.companiesLogos(res.mediaUrl)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  // const redirectToSignup = async ({ salesType, phone }) => {
  //   try {
  //     let queryPositionIds = SALES_TYPE_POSITIONS[salesType].join(",")
  //     const res = await CompanyApi.getPositionStats(queryPositionIds)
  //     if (res.success) {
  //       const { positionId } = res.positionData.sort((a, b) => a.totalUsers - b.totalUsers)[0]
  //       history.replace({
  //         pathname: `/signup/${orgType}/${orgId}/${positionId}`,
  //         state: {
  //           redirectedFromRandomizer: true,
  //           country,
  //           phone,
  //         }
  //       })
  //     }
  //   } catch (err) {
  //     throw new Error(err)
  //   }
  // }

  const redirectToOtp = ({ posId, linkId, phone }) => {
    storage.set.loginType("phone")
    history.replace({
      pathname: `/home/${linkId}`,
      state: {
        redirectedFromRandomizer: true,
        email: "",
        country,
        phone,
        posId,
      }
    })
  }

  const handleContinue = async ({ phone, salesType }) => {
    try {
      setSubmitting(true)
      const res = await CompanyApi.getUserDetails(orgId, phone)
      if (res.success) {
        if (res.userDetails.exist) {
          redirectToOtp({ posId: res.userDetails.positionId, linkId: res.userDetails.linkId, phone })
        } else {
          // redirectToSignup({ salesType, phone })
          const positionId = SALES_TYPE_POSITION_MAP[salesType]
          history.replace({
            pathname: `/signup/${orgType}/${orgId}/${positionId}`,
            state: {
              redirectedFromRandomizer: true,
              country,
              phone,
            }
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setSubmitting(false)
    }
  }

  return loading
    ? <section className="overflowY-hidden overflowX-hidden h-full-page bg-color-primary flex flex-col justify-center items-center">
      <Spin
        indicator={<LoadingOutlined spin style={{ color: "#fff", fontSize: 28 }} />}
      />
    </section>
    : (
      <div className="positions-randomizer-container">
        <HeroPageTemplate
          heading={["Welcome", <br />, "aboard! 👋🏻"]}
          content={"Hello!! We are excited to have you be a part of hiring process with Piramal Finance."}
          companyLogo={companyLogo}
          hideBgBars={isMobile}
          isMobile={isMobile}
          headingSize={60}
        >
          <p className="size-16 color-primary weight-400 m-0">Are you working in Retail Loan Sales business, which types of Loans product you sell ?</p>
          <UserForm
            form={userDetailForm}
            autoComplete="off"
            autoCapitalize="off"
            className="randomizer-form"
            submitForm={handleContinue}
            formInitalValues={{
              phone: null,
              salesType: null,
            }}
          >
            <Form.Item name="salesType"
              rules={[
                {
                  required: true,
                  message: "Please choose a type",
                },
              ]}
            >
              <Select
                placeholder="Choose your answer"
                suffixIcon={<Dropdown />}
                className={`mt-10 salestype-select mb-10`}
                popupClassName="salestype-select-popup"
                options={Object.keys(SALES_TYPES_OPTIONS).map(key => ({ value: key, label: SALES_TYPES_OPTIONS[key], disabled: SALES_TYPE_POSITIONS[key].length === 0 }))}
                onChange={(val) => userDetailForm.setFieldValue("salesType", val)}
              />
            </Form.Item>
            <Form.Item name="phone">
              <PhoneInput
                placeholder="Phone Number"
                className="randomizer-phone mt-10"
                overlayClassName="randomizer-form"
                setValue={(value) => userDetailForm.setFieldValue("phone", value)}
                country={country}
                hasPhoneLogin={true}
                setCountry={setCountry}
              />
            </Form.Item>
            <Button
              className="font-medium br-20 flex justify-center"
              type="primary"
              loading={submitting}
              htmlType="submit"
            >
              Continue
            </Button>
          </UserForm>
        </HeroPageTemplate>
      </div>
    )
}

export default PositionsRandomizer
